// extracted by mini-css-extract-plugin
export default {"loading":"Loader_loading__f8b3Y","laoder_container":"Loader_laoder_container__FEjCz","scale":"Loader_scale__0N5Cf"};